import * as React from 'react';
import classNames from 'classnames';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Flex, Text, Dialog, Avatar} from 'components/UIKit';
import * as locales from '../../locales';
import {SellerInformation as SellerInformationType} from '../../types';
import styles from './SellerInformation.scss';

export interface SellerInformationProps {
  sellerInfo: SellerInformationType;
  inline?: boolean;
}

function SellerInformationComponent({
  sellerInfo,
  inline = false,
  i18n,
}: SellerInformationProps & WithI18nProps) {
  const showBio = Boolean(!inline && sellerInfo.bio);

  return (
    <div className={classNames(styles.Container, {[styles.Inline]: inline})}>
      <Flex
        className={styles.Header}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Avatar
          fallback={sellerInfo.initials}
          imageSrc={sellerInfo.avatar}
          className={styles.Avatar}
          gravatarUrl={sellerInfo.gravatarUrl}
        />
        <Flex direction="column">
          <Text resetMargin type="h3" text={sellerInfo.name} className={styles.Seller} />
          <Text
            resetMargin
            secondary
            className={styles.Since}
            text={i18n.translate('currentOwner')}
          />
        </Flex>
      </Flex>
      {showBio && (
        <Dialog position="topLeft">
          <Text text={sellerInfo.bio} resetMargin />
        </Dialog>
      )}
    </div>
  );
}

export const SellerInformation = withI18n({
  id: 'Listing',
  fallback: locales.en,
})(SellerInformationComponent);
